<template>
  <div>
    <b-container class="mt-5 mb-5">
      <div class="mb-2 clearfix">
        <h1 class="fs-4 font-weight-bold mb-0">Bewerk ticket</h1>
      </div>
      <EventCanceledAlert :event="event" />
      <ValidationObserver ref="form" slim>
        <b-card>
          <EventTicket :event="event" :ticket="form" />
        </b-card>
        <template v-if="!event.canceled_at">
          <div class="mt-3 clearfix">
            <b-button @click="removeTicket()" variant="danger">
              Verwijderen
              <font-awesome-icon icon="fa-solid fa-remove ml-2" />
            </b-button>
            <b-button
              @click="submitForm()"
              variant="primary"
              class="float-right"
            >
              Opslaan
              <font-awesome-icon icon="fa-solid fa-chevron-right ml-2" />
            </b-button>
          </div>
        </template>
      </ValidationObserver>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { mapActions } from "pinia";
import { useShopStore } from "@/stores/shop";

import EventTicket from "@/components/event/EventTicket.vue";
import EventCanceledAlert from "@/components/event/EventCanceledAlert";

export default {
  metaInfo: {
    title: "Tickets",
  },
  components: {
    EventCanceledAlert,
    ValidationObserver,
    EventTicket,
  },
  data() {
    return {
      form: {},
      event: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions(useShopStore, ["setLoading"]),
    async submitForm() {
      let check = await this.$refs["form"].validate();

      if (!check) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        return;
      }

      this.$axios
        .put(
          "https://api.tixgo.nl/eventstickets/" + this.$route.params.ticket,
          this.form,
        )
        .then((response) => {
          response;
          this.$router.push(
            "/manage/events/" + this.$route.params.id + "/settings/tickets",
          );
        });
    },
    removeTicket: function () {
      if (confirm("Weet je zeker dat je dit ticket wilt verwijderen?")) {
        this.$axios
          .delete(
            "https://api.tixgo.nl/eventstickets/" + this.$route.params.ticket,
          )
          .then((response) => {
            response;
            this.$router.push(
              "/manage/events/" + this.$route.params.id + "/settings/tickets",
            );
          });
      }
    },
    fetchTicket: function () {
      this.setLoading(true);

      this.$axios
        .get("https://api.tixgo.nl/eventstickets/" + this.$route.params.ticket)
        .then((response) => {
          if (response.data) {
            this.form = response.data;

            this.setLoading(false);
          }
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    fetchEvent: function () {
      this.setLoading(true);

      this.$axios
        .get("https://api.tixgo.nl/events/" + this.$route.params.id)
        .then((response) => {
          this.event = response.data;

          this.setLoading(false);
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
  },
  created() {
    this.fetchTicket();
    this.fetchEvent();
  },
};
</script>
